import { z } from 'zod';

/**
 * Health endpoint Zod schemas for Polymarket Gamma API
 */

export const HealthCheckRequestSchema = z.object({});

export const HealthCheckResponseSchema = z.object({
  data: z.string(),
});
